import Objects from "./Objects";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { dayMonthYearAtTimeWithSeconds } from "./dates";

export default class PDFUtils {

  static convertArrayOfObjectsToPDF({ data, columns, title, lineDelimiter = '\n' }) {
    if (Objects.isNullOrUndefined(data)) {
      return null;
    }

    const cols = columns.map(x => x.Header);
    const rows = [];

    data.forEach(function (item) {
      const objectRowArray = [];
      columns.forEach(function (column) {
        objectRowArray.push(Objects.getValueByCustomField(column.accessor, item));
      });
      rows.push(objectRowArray)
    });

    var doc = new jsPDF('l', 'mm', [800, 1400]);
    doc.text(title, 250, 15,  null, null, 'center');
    doc.autoTable(cols, rows, {margin: {top: 30}});
    doc.save('Relatório de ' + title + '.pdf');
  }

  static generatePortalPDF({ id, checkpoint, createdAt, movementOrder, username, destination, items }, portalName) {
    const rows = []

    const breakLine = (text) => {
      return doc.splitTextToSize(text, 45)
    }

    var doc = new jsPDF();
    doc.text(105, 15, 'Operação do Portal', null, null, 'center');
    doc.setFontSize(8);

    let y = 25;
    let ySub = 30;

    doc.setFontSize(10);
    doc.text("ID da operação", 10, y);
    doc.setFontSize(8);
    doc.text(breakLine(id), 10, ySub);


    doc.setFontSize(10);
    doc.text("Data/hora Inicio", 60, y);
    doc.setFontSize(8);
    doc.text(breakLine(dayMonthYearAtTimeWithSeconds(createdAt)), 60, ySub);

    doc.setFontSize(10);
    doc.text("Operador", 160, y);
    doc.setFontSize(8);
    doc.text(breakLine(username), 160, ySub);

    doc.setFontSize(10);
    doc.text("Tipo movimentação", 110, y);
    doc.setFontSize(8);
    doc.text(breakLine(movementOrder && movementOrder.type ? movementOrder.type : ''), 110, ySub);

    y = 45;
    ySub = 50;

    doc.setFontSize(10);
    doc.text("Código do Romaneio", 10, y);
    doc.setFontSize(8);
    doc.text(breakLine(movementOrder && movementOrder.code ? movementOrder.code : ''), 10, ySub);

    doc.setFontSize(10);
    doc.text("Ponto de Controle", 60, y);
    doc.setFontSize(8);
    doc.text(breakLine(checkpoint && checkpoint.friendlyName ? checkpoint.friendlyName : ''), 60, ySub);

    doc.setFontSize(10);
    doc.text("Local Destino", 110, y);
    doc.setFontSize(8);
    doc.text(breakLine(destination && destination.friendlyName ? destination.friendlyName : ''), 110, ySub);

    doc.setFontSize(10);
    doc.text("Nome do Portal", 160, y);
    doc.setFontSize(8);
    doc.text(breakLine(portalName), 160, ySub);

    items.forEach(x => {
      rows.push([
        x.reference,
        x.friendlyName,
        x.quantityExpected = x.quantityExpected ? x.quantityExpected : '0',
        x.quantityAvailable = '0',
        x.quantityTarget = '0',
        x.quantity = x.quantity = x.quantity ? x.quantity : '0'
      ])
    })

    doc.autoTable(['Referência', 'Descrição', 'Solicitada', 'Disponível', 'Alvo', 'Lida RFID'],rows, { margin: { top: 65 } })

    doc.save('Relatório-Portal.pdf');
  }
}





// WEBPACK FOOTER //
// ./src/utils/PDFUtils.js